import React, { useState, useEffect } from 'react';
import { FaExclamationTriangle } from 'react-icons/fa';
import Navbar from '../Menus/Navbar'
import Footer from '../Menus/Footer'
import HOMEBANNER from '../images/ACBANNER.webp'
import WASHINGMACHINE from '../images/AC.png'
import { FaQuestionCircle } from "react-icons/fa";
import CountUp from 'react-countup';
import { FaSmile, FaMapMarkedAlt, FaThumbsUp } from 'react-icons/fa';
import { useInView } from 'react-intersection-observer';
import './Home.css'
import AOS from 'aos';
import { FaCalendarAlt, FaClock, FaHeadset } from 'react-icons/fa';
// import 'aos/dist/aos.css';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { motion } from "framer-motion";
import WASHWORK1 from '../images/ac.jpg';

import AL2 from "../images/AL2.jpeg";
import AL3 from "../images/AL3.jpg";
import AL4 from "../images/AL4.jpg";
import AL6 from "../images/AL6.jpeg";
import { FaPhoneAlt } from 'react-icons/fa';

export default function ACService() {




  const faqs = [
    {
      question: "What makes your AC service low-cost?",
      answer: "Our AC service is affordable because we streamline our operations and reduce unnecessary overheads. We pass those savings directly to our customers."
    },
    {
      question: "What is your policy on repeat AC issues?",
      answer: "If the same AC problem reoccurs within one month, we provide a free follow-up service to fix it at no extra cost."
    },
    {
      question: "Do you provide a warranty on AC spare parts?",
      answer: "Yes, we provide a 3 to 6-month warranty on all AC spare parts. The warranty duration varies depending on the part and manufacturer."
    },
    {
      question: "Can I see the AC spare parts before installation?",
      answer: "Absolutely. We always show customers the spare parts before installation to maintain transparency and build trust."
    },
    {
      question: "How can I schedule an AC service?",
      answer: "You can call us anytime — we are available 24/7. Our team will schedule a service visit at your convenience."
    },
    {
      question: "What types of AC issues do you handle?",
      answer: "We handle all types of AC problems including gas leakage, compressor faults, cooling issues, water leakage, and routine maintenance."
    },
    {
      question: "Are your technicians experienced in AC service?",
      answer: "Yes, our technicians are highly trained and experienced in servicing all brands and models of air conditioners."
    },
    {
      question: "Do you offer emergency AC repair services?",
      answer: "Yes, we provide emergency AC repair services for urgent situations requiring immediate attention."
    },
    {
      question: "How can I make my AC last longer?",
      answer: "Regular servicing, cleaning filters, and timely repairs can increase the lifespan of your AC. We also offer helpful maintenance tips."
    },
    {
      question: "What if I have more questions about AC service?",
      answer: "Feel free to reach out to us anytime. Our support team is always ready to assist you with all your AC service concerns."
    }
  ];


  const tips = [
    {
      title: "Clean or Replace Air Filters Regularly",
      content: "Dirty filters restrict airflow and reduce efficiency. Clean or replace them every 1–2 months."
    },
    {
      title: "Check Thermostat Settings",
      content: "Ensure your thermostat is set to the correct mode and temperature for optimal comfort and savings."
    },
    {
      title: "Inspect Outdoor Unit",
      content: "Keep the outdoor condenser unit clean and free of debris like leaves, dirt, or plastic covers."
    },
    {
      title: "Ensure Proper Ventilation",
      content: "Make sure that air vents are not blocked by furniture or curtains to allow proper air circulation."
    },
    {
      title: "Schedule Seasonal Maintenance",
      content: "Have your AC professionally inspected and serviced before the peak summer season."
    },
    {
      title: "Use a Programmable Thermostat",
      content: "A programmable thermostat helps reduce energy usage by adjusting the temperature when you're away."
    },
    {
      title: "Seal Leaky Ducts",
      content: "Leaky air ducts reduce efficiency. Have them inspected and sealed if necessary."
    },
    {
      title: "Check Refrigerant Levels",
      content: "Low refrigerant can reduce cooling performance. Let a professional inspect and recharge it if needed."
    },
    {
      title: "Avoid Frequent ON/OFF Cycling",
      content: "Constant switching damages components. Let your AC run its full cycle for better performance."
    },
    {
      title: "Call a Professional for Issues",
      content: "If your AC makes unusual noises or doesn't cool effectively, contact a qualified technician immediately."
    }
  ];





  const accordionData = [
    {
      title: "AC Repair Services",
      content: "We repair all types of AC issues including cooling problems, electrical faults, and more with expert precision."
    },
    {
      title: "AC Maintenance",
      content: "Regular maintenance to keep your air conditioner running efficiently and extend its lifespan."
    },
    {
      title: "AC Installation",
      content: "We offer secure and efficient installation for split, window, and inverter AC units."
    },
    {
      title: "AC Troubleshooting",
      content: "We diagnose and resolve performance or technical issues quickly and accurately."
    },
    {
      title: "AC Parts Replacement",
      content: "We replace damaged parts like compressors, fans, condensers, and PCBs using genuine components."
    }
  ];



  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const toggleTip = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const services = [
    { title: "AC Repairing", desc: "Quick Diagnosis", img: AL2 },
    { title: "AC Maintenance", desc: "High-Quality Clean", img: AL3 },
    { title: "AC Installation", desc: "Preventive Maintenance", img: AL4 },
    { title: "AC Service", desc: "Gas Chekup", img: AL6 },

  ];



  const [ref, inView] = useInView({ triggerOnce: true });

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    city: '',
    appliance: '',
    issue: ''
  });

  const handleChange = e => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = e => {
    e.preventDefault();
    const { name, phone, city, appliance, issue } = formData;
    const message = `New Complaint:%0AName: ${name}%0APhone: ${phone}%0ACity: ${city}%0AAppliance: ${appliance}%0AIssue: ${issue}`;
    const whatsappURL = `https://wa.me/919342851992?text=${message}`; // Replace with your number
    window.open(whatsappURL, '_blank');
  };







  return (
    <>
      <Navbar />

      <section id="Banner-home" className="banner-home" style={{ backgroundImage: `url(${HOMEBANNER})` }}>
        <div className="banner-overlay">
          <div className="banner-container">
            {/* Left Side */}
            <div className="banner-left glass-effect">
              <h1 className="headline">AC Service Center</h1>
              <a href="tel:+919342851992" className="call-btn">
                <FaPhoneAlt style={{ marginRight: '8px' }} />
                +919342851992
              </a>
            </div>

            {/* Right Side - Contact Form */}
            <div className="banner-right">
              <form className="contact-form" onSubmit={handleSubmit}>
                <input type="text" name="name" placeholder="Your Name" required onChange={handleChange} />
                <input type="tel" name="phone" placeholder="Phone Number" required onChange={handleChange} />
                <input type="text" name="city" placeholder="City" required onChange={handleChange} />
                <select name="appliance" required onChange={handleChange}>
                  <option value="">Select Appliance</option>
                  <option value="Washing Machine">Washing Machine</option>
                  <option value="Refrigerator">Refrigerator</option>
                  <option value="AC">AC</option>
                  <option value="TV">TV</option>
                </select>
                <textarea name="issue" placeholder="Tell us your issue..." required onChange={handleChange}></textarea>
                <button type="submit" className="submit-btn">Submit & Send to WhatsApp</button>
              </form>
            </div>
          </div>
        </div>
      </section>




      <section id="home-about">
        <div className="about-container">
          {/* Left Side */}
          <div className="about-left" data-aos="fade-left">
            <h2>About Our Company</h2>
            <h3>Home Appliance Assist</h3>
            <p>
              If your air conditioner stops working, don’t stress. Contact us, and we’ll resolve the issue quickly and professionally. We provide convenient, on-site AC repair services — simply schedule a service call, and our experts will come to your location. Or, visit us directly and our skilled technicians will fix the problem efficiently. We offer reliable and expert AC services for all types and brands, including split ACs and window ACs. With over <strong>8+ years</strong> of experience in the appliance service industry, Home Appliance Assist is committed to delivering top-quality workmanship and complete customer satisfaction.
            </p>


            <img src={WASHINGMACHINE} alt='washing machine service' title='washing machine repair' className='img-fluid' />
          </div>

          {/* Right Side Boxes */}
          <div className="about-right">
            <h3>Issue In Air Conditioner</h3>
            <div className="service-box" data-aos="fade-right" data-aos-delay="100">
              <p>AC Not Cooling Properly</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="200">
              <p>Water Leakage from Indoor Unit</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="300">
              <p>Unusual Noise During Operation</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="400">
              <p>AC Not Turning On</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="500">
              <p>Foul Smell from AC Vents</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="600">
              <p>Fan Not Working Properly</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="700">
              <p>Gas Leakage or Low Refrigerant</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="800">
              <p>Compressor Not Working</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="900">
              <p>Remote Control Not Responding</p>
            </div>
            <div className="service-box" data-aos="fade-right" data-aos-delay="1000">
              <p>AC Needs Regular Servicing</p>
            </div>


          </div>
        </div>
      </section>



      <section id="washing-machine-service" className="washing-service-section">
        <h2 className="section-title">What We Do for AC Service</h2>
        <div className="washing-service-grid">
          {services.map((service, index) => (
            <motion.div
              className="washing-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.2 }}
              viewport={{ once: true }}
            >
              <img src={service.img} alt={service.title} className="washing-img" />
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      <section id="washing-accordion-section" className="accordion-wrapper">
        <div className="accordion-container">
          <div className="accordion-image">
            <img src={WASHWORK1} alt="Washing Machine Service" />
          </div>
          <div className="accordion-content">
            <h2>Air Conditioner Service Details</h2>
            {accordionData.map((item, index) => (
              <div className="accordion-item" key={index}>
                <div
                  className={`accordion-title ${activeIndex === index ? "active" : ""}`}
                  onClick={() => toggleAccordion(index)}
                >
                  <h3>{item.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div
                  className={`accordion-body ${activeIndex === index ? "open" : ""}`}
                >
                  <p>{item.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      {/*    
     <section id="desc" className="service-section">
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>Washing Machine Issues?</h2>
           <p>
             Is your washing machine making noise, not spinning, or leaking water? Don’t worry — our trained experts diagnose and fix all issues quickly. 
             We offer <strong>same-day doorstep service</strong> to get your appliance back up and running smoothly.
           </p>
           <a href="/washing-machine-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={WASHINGMACHINE} alt="Washing Machine Service" />
         </div>
       </div>
     
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>AC Not Cooling?</h2>
           <p>
             Whether it's low cooling, water leakage, or unusual noise, our technicians provide <strong>same-day AC repair</strong> with expert diagnostics and professional care.
           </p>
           <a href="/ac-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={AC} alt="AC Service" />
         </div>
       </div>
     
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>Fridge Not Working?</h2>
           <p>
             Experiencing cooling issues or strange noises? Let our experienced technicians help. We offer <strong>quick same-day service</strong> for all fridge problems.
           </p>
           <a href="/fridge-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={REF} alt="Fridge Service" />
         </div>
       </div>
     
       <div className="service-item" data-aos="fade-right">
         <div className="service-text">
           <h2>TV Not Turning On?</h2>
           <p>
             From screen issues to sound problems, we repair all types of TVs — LED, LCD, Smart TVs and more. Our <strong>same-day service</strong> ensures quick solutions.
           </p>
           <a href="/tv-service" className="service-btn">Fix Now</a>
         </div>
         <div className="service-image" data-aos="fade-left">
           <img src={TV} alt="TV Service" />
         </div>
       </div>
     </section>
     
     
  
     
      */}



      <section id="washing-tips-section" className="tips-wrapper">
        <div className="tips-container">
          <h2>Air Conditioner Tips and Tricks</h2>
          <div className="tips-accordion">
            {tips.map((tip, index) => (
              <div className="tip-item" key={index}>
                <div className="tip-header" onClick={() => toggleTip(index)}>
                  <h3>{index + 1}. {tip.title}</h3>
                  <span>{activeIndex === index ? <FaChevronUp /> : <FaChevronDown />}</span>
                </div>
                <div className={`tip-body ${activeIndex === index ? "open" : ""}`}>
                  <p>{tip.content}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>


      <section id="why-us" className="why-us-section">
        <div className="why-us-heading" data-aos="fade-up">
          <h2>Why Choose Us?</h2>
        </div>
        <div className="why-us-grid">
          <div className="why-us-card" data-aos="fade-right">
            <h3>Expert Technicians</h3>
            <p>Our team consists of certified experts with years of experience in appliance repairing and maintenance.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Quick Service</h3>
            <p>We value your time and offer prompt service, ensuring your appliances are up and running in no time.</p>
          </div>
          <div className="why-us-card" data-aos="fade-right">
            <h3>Quality Assurance</h3>
            <p>We use genuine parts and provide a guarantee on our work, so you can trust in the quality of our service.</p>
          </div>
          <div className="why-us-card" data-aos="fade-left">
            <h3>Affordable Pricing</h3>
            <p>Our pricing is transparent and competitive, ensuring you get the best value for your money.</p>
          </div>
        </div>
      </section>

      <section id="impact" className="impact-section" ref={ref}>
        <h2 className="impact-heading" data-aos="fade-up">Our Impact in Numbers</h2>
        <div className="impact-container">
          <div className="impact-card" data-aos="fade-up" data-aos-delay="100">
            <FaSmile className="impact-icon" />
            <h2>{inView && <CountUp end={50000} duration={2} />}+</h2>
            <p>Happy Customers</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="200">
            <FaMapMarkedAlt className="impact-icon" />
            <h2>{inView && <CountUp end={60} duration={2} />}+</h2>
            <p>Areas Covered</p>
          </div>
          <div className="impact-card" data-aos="fade-up" data-aos-delay="300">
            <FaThumbsUp className="impact-icon" />
            <h2>{inView && <CountUp end={49000} duration={2} />}+</h2>
            <p>Satisfied Customers</p>
          </div>
        </div>
      </section>
      <section id="washing-faq-section" className="faq-section">
        <div className="faq-container">
          <h2>Frequently Asked Questions</h2>
          <div className="faq-grid">
            {faqs.map((faq, index) => (
              <div className="faq-card" key={index}>
                <div className="faq-icon">
                  <FaQuestionCircle />
                </div>
                <h3 className="faq-question">{faq.question}</h3>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="availability" className="availability-section">
        <h2 className="availability-heading" data-aos="fade-up">Our Availability</h2>
        <div className="availability-grid">
          <div className="availability-card" data-aos="fade-right">
            <FaCalendarAlt className="availability-icon" />
            <h3>Opening Day</h3>
            <p>
              Monday to Saturday <br />
              <span className="sunday-text">Sunday - Closed</span>
            </p>
          </div>
          <div className="availability-card" data-aos="fade-up">
            <FaClock className="availability-icon" />
            <h3>Office Available</h3>
            <p>9:00 AM to 9:00 PM</p>
          </div>
          <div className="availability-card" data-aos="fade-left">
            <FaHeadset className="availability-icon" />
            <h3>Customer Support</h3>
            <p>24/7 Available</p>
          </div>
        </div>
      </section>


      <section id="disclaimer" className="disclaimer-section" data-aos="fade-up">
        <div className="disclaimer-container">
          <div className="disclaimer-icon">
            <FaExclamationTriangle />
          </div>
          <div className="disclaimer-content">
            <h2>Disclaimer</h2>
            <p>
              Home Appliance Assist is an independent service provider offering expert repairing and maintenance services for a wide range of home appliances. We specialize in servicing all major home appliance types, including refrigerators, washing machines, air conditioners, and televisions.
            </p>
            <p>
              Please note that Home Appliance Assist is not affiliated with, endorsed by, or associated with any specific appliance manufacturers or brands. We do not use any brand names, trademarks, or logos on our website or in our promotional materials. All services provided are carried out by our team of experienced and certified technicians, independent of any manufacturer's certification.
            </p>
            <p>
              While we provide high-quality service for various appliance types, our services are not authorized by or affiliated with the manufacturers of the products we repair. Customers seeking manufacturer-authorized service and genuine parts should contact the official customer support of the respective brands.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </>

  )
}
